import React, { Component } from 'react'
import {
  Correct,
  Letter,
  LetterMarker,
  NextQuestion,
  Question,
  ResetButton,
  Wrapper,
} from './styled'
import { dummyQuestions, dummyLetters } from './dummyData'

class WordGame extends Component {
  constructor(props) {
    super(props)
    this.size = 50
    this.top = 90
    this.multiplier = this.size + 30
    this.state = {
      loaded: false,
      currentLetter: 1,
      currentQuestion: 0,
      answerCorrect: false,
      lettersComplete: false,
      selectedLetters: [],
      question: {},
      letters: [],
    }
  }

  fetchQuestionData() {
    // call the api with this.state.currentQuestion
    this.setState({
      question: dummyQuestions[this.state.currentQuestion],
      letters: dummyLetters[this.state.currentQuestion],
    })
  }

  componentDidMount() {
    this.fetchQuestionData()
    setTimeout(() => {
      this.setState({ loaded: true })
    }, 1000)
  }

  handleClickLetter = async ev => {
    ev.preventDefault()
    const id = ev.target.attributes['data-id'].value
    const checkGame = () => {
      if (this.state.letters.length + 1 === this.state.currentLetter) {
        // check if correct
        if (
          this.state.selectedLetters.join('') === this.state.question.answer
        ) {
          this.setState({ answerCorrect: true })
        }
        this.setState({ lettersComplete: true })
      }
    }
    if (
      this.state.letters.filter(letter => letter.id.toString() === id)[0].locked
    ) {
      return
    }
    await this.setState(state => ({
      letters: state.letters.map(letter =>
        letter.id.toString() !== id
          ? letter
          : {
              ...letter,
              endPos: state.currentLetter * this.multiplier,
              locked: true,
            }
      ),
      selectedLetters: [
        ...state.selectedLetters,
        this.state.letters.filter(letter => letter.id.toString() === id)[0]
          .letter,
      ],
    }))
    await this.setState(state => ({ currentLetter: state.currentLetter + 1 }))
    await checkGame()
  }

  handleResetLetters = async ev => {
    ev.preventDefault()
    await this.setState(state => ({
      letters: state.letters.map(letter => ({
        ...letter,
        endPos: 0,
        locked: false,
      })),
      currentLetter: 1,
      selectedLetters: [],
      answerCorrect: false,
      lettersComplete: false,
    }))
  }

  handleNextQuestion = async ev => {
    // reset data
    ev.preventDefault()
    await this.setState(state => ({
      letters: state.letters.map(letter => ({
        ...letter,
        endPos: 0,
        locked: false,
      })),
      currentLetter: 1,
      selectedLetters: [],
      answerCorrect: false,
      lettersComplete: false,
      currentQuestion: state.currentQuestion + 1,
    }))
    // fetch new question
    await this.fetchQuestionData()
    // reload page
  }

  render() {
    return !this.state.loaded ? (
      <Wrapper>Loading</Wrapper>
    ) : (
      <Wrapper>
        {this.state.letters.map((letter, key) => (
          <Letter
            data-id={letter.id}
            key={key}
            locked={letter.locked}
            onClick={this.handleClickLetter}
            size={this.size}
            top={letter.top}
            endPos={letter.endPos}
            left={letter.startPos}
            lettersComplete={this.state.lettersComplete}
            answerCorrect={this.state.answerCorrect}
          >
            {letter.letter}
          </Letter>
        ))}

        {this.state.letters.map((marker, key) => (
          <LetterMarker
            size={this.size}
            key={key}
            top={this.top + 70}
            left={marker.id * this.multiplier}
            highlighted={marker.id <= this.state.currentLetter}
          />
        ))}
        {!this.state.answerCorrect ? (
          <ResetButton
            leftPos={(this.state.letters.length + 1) * this.multiplier}
            onClick={this.handleResetLetters}
          >
            {'Reset'}
          </ResetButton>
        ) : null}
        {this.state.answerCorrect ? (
          <Correct>
            {'Well Done!'}
            <NextQuestion onClick={this.handleNextQuestion}>
              {'Next Question'}
            </NextQuestion>
          </Correct>
        ) : null}
        <Question>{this.state.question.question}</Question>
      </Wrapper>
    )
  }
}

export default WordGame
